import "./pagination.css";
import LongArrowRight from "../../../assets/icons/LongArrowRight";
import LongArrowLeft from "../../../assets/icons/LongArrowLeft";

interface PaginationProps {
    page?: number;
    pageSize?: number;
    total?: number;
    onPaginating: (newPage: number) => void;
}

const Pagination = ({ page, pageSize, total, onPaginating }: PaginationProps) => {
    if(page === undefined || !pageSize || !total) return null;
    const totalPages = Math.ceil(total / pageSize);
    const totalPagesToShow = Math.min(totalPages, 5);
    const minPageToShow = Math.max(page - 2, 1);
    const maxPageToShow = Math.min(page + 2, totalPages - 1);
    const pagesToShow = [];
    let pageToPush = minPageToShow;
    let nextNavigationPage = Math.max(page - 2, 0);
    while(nextNavigationPage < page) {
        pagesToShow.push(nextNavigationPage);
        nextNavigationPage++
    }
    nextNavigationPage = page + 1;
    pagesToShow.push(page);
    while(nextNavigationPage < Math.min(page + 3, totalPages)) {
        pagesToShow.push(nextNavigationPage);
        nextNavigationPage++
    }

    const goTo = (pageNum: number) => () => {
        onPaginating(pageNum);
    }

    if(totalPages <= 1) return null;

    return <div className="pagination-container flex centered">
        {page > 0 ? <div className="pagination-item" onClick={goTo(Math.max(page - 1, 0))}><LongArrowLeft width={12}  /></div> : null}
        <div className="flex centered">
            {pagesToShow.map(pageToShow => <div key={`table-pagination-${page}-${pageToShow}`} className={`pagination-item ${pageToShow === page ? 'current' : ''}`} onClick={goTo(pageToShow)}>
                {pageToShow + 1}
            </div>)}
        </div>
        {page < totalPages - 1 ? <div className="pagination-item" onClick={goTo(Math.min(page + 1, totalPages - 1))}><LongArrowRight width={12} /></div> : null}
    </div>
}

export default Pagination;